export default {
  path: '/v5/play',
  name: 'V5_play',
  component: () => import('./PlayNowPage.vue'),
};
